import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async current () {
    return axios.get('/api/eosaccounts/current').then(r => r.data)
  },
  async getChallengeForLogin ({accountName}) {
    return axios.post('/api/eosaccounts/get-challenge', { accountName })
      .then(r => r.data).catch(errorHandler)
  },
  async verifySignatureForLogin ({challengeId, eosAccountName, eosAccountPermission, signed}) {
    return axios.post('/api/eosaccounts/verify', { challengeId, eosAccountName, eosAccountPermission, signed })
      .then(r => r.data).catch(errorHandler)
  },
  async attach ({accountName, accountPermission}) {
    return axios.post('/api/eosaccounts/attach', {accountName, accountPermission})
      .then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/eos-accounts.js